"use strict";
/*
 * Created on 16.10.2018
 */

var _toConsumableArray = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _immutable_1$Set, _immutable_1$Set2;

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var moment = require("moment");

var CodebookLookupSequence_1 = require("../../core/model/codebook/CodebookLookupSequence");

var DateParser_1 = require("../../core/model/data-dictionary/parsers/DateParser");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var StringLengthValidator_1 = require("../../core/model/data-dictionary/validators/StringLengthValidator");

var EntityStateFlag_1 = require("../../core/model/EntityStateFlag");

var StateDomainObject_1 = require("../../core/model/StateDomainObject");

var UserInfo_1 = require("../../user/model/UserInfo");

var ManualPromoWeekSplit_1 = require("./ManualPromoWeekSplit");

var PromotionSplitOptionEnum_1 = require("./PromotionSplitOptionEnum");

var PromotionStateEnum_1 = require("./PromotionStateEnum");

var PromotionWarningFlag_1 = require("./PromotionWarningFlag");

var StoreSpecificationEnum_1 = require("./StoreSpecificationEnum");
/**
 * @author MSu
 */


var Promotion =
/*#__PURE__*/
function (_StateDomainObject_1$) {
  _inherits(Promotion, _StateDomainObject_1$);

  /**
   * @param id ID of promotion
   * @param externalId ID of promotion used in external systems (Gold, ...)
   * @param workflowCaseId workflow case associated with the promotion
   * @param workflowState state of the workflow as presented to the user
   * @param workflowModified last time of workflow activity
   * @param name name of promotion action
   * @param promotionTypeId reference to type of promotion
   * @param description description of promotion
   * @param dateFrom start of promotion action
   * @param dateTo end of promotion action
   * @param groupOfSitesId Identification of sites affected by the promotion, window items in promotion may refer to other set of
   *        sites, the final set of sites within which a product is promoted, is computed by so called 'number of sites' algorithm.
   * @param ecommerce whether this is e-commerce promotion
   * @param opening opening leaflet/promotion; created for e.g. after site remodeling as described in PROMO-402
   * @param storeSpecification defines store specification for filtering purposes
   * @param themeIds themes of promotion, window in promotion may refer only to themes from this set
   * @param created creation date of the promotion
   * @param createdBy identification of user that created the promotion
   * @param modified last modification date of the promotion
   * @param modifiedBy identification of last user who modified the promotion
   * @param stateFlags state flags
   * @param assignedMasterArea Flag which determines whether a master area is assigned to this promotion. Information should be synced
   *        each time a promotion area is assigned/unassigned from the promotion.
   * @param lastEffect date of last effect on prices the promotion may have. Initially set to end of promotion date, later prolonged by
   *        largest post promo effect interval of window items in the promotion.
   * @param promoSplitOption - identify option for promo split calculation
   * @param warningFlags
   * @param processed defines whether an instance was processed (used primarily for import)
   */
  function Promotion(id, externalId, workflowCaseId, workflowState, workflowModified, name, promotionTypeId, description, dateFrom, dateTo, groupOfSitesId, ecommerce, opening) {
    var _this;

    var storeSpecification = arguments.length > 13 && arguments[13] !== undefined ? arguments[13] : StoreSpecificationEnum_1.StoreSpecificationEnum.NONE;
    var themeIds = arguments.length > 14 ? arguments[14] : undefined;
    var created = arguments.length > 15 ? arguments[15] : undefined;
    var createdBy = arguments.length > 16 ? arguments[16] : undefined;
    var modified = arguments.length > 17 ? arguments[17] : undefined;
    var modifiedBy = arguments.length > 18 ? arguments[18] : undefined;
    var stateFlags = arguments.length > 19 ? arguments[19] : undefined;
    var assignedMasterArea = arguments.length > 20 ? arguments[20] : undefined;
    var lastEffect = arguments.length > 21 ? arguments[21] : undefined;
    var promoSplitOption = arguments.length > 22 ? arguments[22] : undefined;
    var manualSplits = arguments.length > 23 ? arguments[23] : undefined;
    var warningFlags = arguments.length > 24 ? arguments[24] : undefined;
    var processed = arguments.length > 25 ? arguments[25] : undefined;
    var snapshotOriginId = arguments.length > 26 ? arguments[26] : undefined;

    _classCallCheck(this, Promotion);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Promotion).call(this, stateFlags));
    _this.id = id;
    _this.externalId = externalId;
    _this.workflowCaseId = workflowCaseId;
    _this.workflowState = workflowState;
    _this.workflowModified = workflowModified;
    _this.name = name;
    _this.promotionTypeId = promotionTypeId;
    _this.description = description;
    _this.dateFrom = dateFrom;
    _this.dateTo = dateTo;
    _this.groupOfSitesId = groupOfSitesId;
    _this.ecommerce = ecommerce;
    _this.opening = opening;
    _this.storeSpecification = storeSpecification;
    _this.themeIds = themeIds;
    _this.created = created;
    _this.createdBy = createdBy;
    _this.modified = modified;
    _this.modifiedBy = modifiedBy;
    _this.stateFlags = stateFlags;
    _this.assignedMasterArea = assignedMasterArea;
    _this.lastEffect = lastEffect;
    _this.promoSplitOption = promoSplitOption;
    _this.manualSplits = manualSplits;
    _this.warningFlags = warningFlags;
    _this.processed = processed;
    _this.snapshotOriginId = snapshotOriginId;
    return _this;
  }

  _createClass(Promotion, [{
    key: "isExtensible",
    value: function isExtensible() {
      return this.workflowState !== null && Promotion.EXTENSIBLE_STATES.contains(this.workflowState);
    }
  }, {
    key: "isExtensiblePlusActive",
    value: function isExtensiblePlusActive() {
      return this.workflowState !== null && Promotion.EXTENSIBLE_STATES_PLUS_ACTIVE.has(this.workflowState);
    }
  }, {
    key: "isExtensibleImportExcel",
    value: function isExtensibleImportExcel() {
      return this.workflowState !== null && Promotion.EXTENSIBLE_STATES_IMPORT_EXCEL.has(this.workflowState);
    }
  }, {
    key: "isExtensibleByCopyWindow",
    value: function isExtensibleByCopyWindow() {
      return this.workflowState !== null && Promotion.EXTENSIBLE_BY_COPY_WINDOW_STATES.contains(this.workflowState);
    }
  }, {
    key: "isExtensibleByMoveWindow",
    value: function isExtensibleByMoveWindow() {
      return this.workflowState !== null && Promotion.EXTENSIBLE_BY_MOVE_WINDOW_STATES.contains(this.workflowState);
    }
  }, {
    key: "isPromotionAreaAssignable",
    value: function isPromotionAreaAssignable() {
      return this.workflowState !== null && Promotion.PROMOTION_AREA_ASSIGNABLE_STATES.contains(this.workflowState);
    }
  }, {
    key: "isHistorical",
    value: function isHistorical() {
      return this.dateTo.isBefore(moment());
    }
  }, {
    key: "isFuture",
    value: function isFuture() {
      return this.dateFrom.isAfter(moment());
    }
  }, {
    key: "isOngoing",
    value: function isOngoing() {
      var now = moment();
      return this.dateFrom.isSameOrBefore(now) && this.dateTo.isSameOrAfter(now);
    }
  }, {
    key: "isImportedFromIDB",
    value: function isImportedFromIDB(importDateBoundary) {
      return this.created.isSameOrBefore(importDateBoundary);
    }
  }, {
    key: "isActive",
    value: function isActive() {
      return this.workflowState === PromotionStateEnum_1.PromotionStateEnum.Active;
    }
  }, {
    key: "isCanceled",
    value: function isCanceled() {
      return this.workflowState === PromotionStateEnum_1.PromotionStateEnum.Canceled;
    }
  }, {
    key: "durationInDays",
    value: function durationInDays() {
      return this.dateTo.diff(this.dateFrom, 'days') + 1;
    }
  }]);

  return Promotion;
}(StateDomainObject_1.StateDomainObject);

exports.Promotion = Promotion;
/**
 * Enumerates states of promotions in which promotion is either before its start or is running.
 */

Promotion.UNFINISHED_STATES = immutable_1.List.of(PromotionStateEnum_1.PromotionStateEnum.Concept, PromotionStateEnum_1.PromotionStateEnum.Open, PromotionStateEnum_1.PromotionStateEnum.Approved, PromotionStateEnum_1.PromotionStateEnum.Closed, PromotionStateEnum_1.PromotionStateEnum.Finalized, PromotionStateEnum_1.PromotionStateEnum.Active);
/** States in which is possible to add windows */

Promotion.EXTENSIBLE_STATES = immutable_1.List.of(PromotionStateEnum_1.PromotionStateEnum.Open, PromotionStateEnum_1.PromotionStateEnum.Approved, PromotionStateEnum_1.PromotionStateEnum.Closed);
/** States in which is possible to add windows {@link Promotion.EXTENSIBLE_STATES} + active state */

Promotion.EXTENSIBLE_STATES_PLUS_ACTIVE = (_immutable_1$Set = immutable_1.Set).of.apply(_immutable_1$Set, _toConsumableArray(Promotion.EXTENSIBLE_STATES).concat([PromotionStateEnum_1.PromotionStateEnum.Active]));
/** States in which is possible to add windows within excel import */

Promotion.EXTENSIBLE_STATES_IMPORT_EXCEL = (_immutable_1$Set2 = immutable_1.Set).of.apply(_immutable_1$Set2, _toConsumableArray(Promotion.EXTENSIBLE_STATES));
/** States in which is possible to add windows by copying them */

Promotion.EXTENSIBLE_BY_COPY_WINDOW_STATES = immutable_1.List.of(PromotionStateEnum_1.PromotionStateEnum.Open, PromotionStateEnum_1.PromotionStateEnum.Approved, PromotionStateEnum_1.PromotionStateEnum.Closed);
/** States in which is possible to add windows by moving them */

Promotion.EXTENSIBLE_BY_MOVE_WINDOW_STATES = immutable_1.List.of(PromotionStateEnum_1.PromotionStateEnum.Open);
/**
 * Enumerates all states in which user should be albe to manage master/promotion areas.
 * <br/>
 * Management of the areas within the 'finalized' state is enabled only for ADMIN user and it should be handled specifically.
 */

Promotion.PROMOTION_AREA_ASSIGNABLE_STATES = immutable_1.List.of(PromotionStateEnum_1.PromotionStateEnum.Concept, PromotionStateEnum_1.PromotionStateEnum.Open, PromotionStateEnum_1.PromotionStateEnum.Approved, PromotionStateEnum_1.PromotionStateEnum.Closed);
/** Possible states to show promotions for Promotion Performance report */

Promotion.REPORTS_PROMOTION_PERFORMANCE_STATES = immutable_1.List.of(PromotionStateEnum_1.PromotionStateEnum.Open, PromotionStateEnum_1.PromotionStateEnum.Approved, PromotionStateEnum_1.PromotionStateEnum.Closed, PromotionStateEnum_1.PromotionStateEnum.Finalized, PromotionStateEnum_1.PromotionStateEnum.Active, PromotionStateEnum_1.PromotionStateEnum.Finished, PromotionStateEnum_1.PromotionStateEnum.Evaluated);
/** Possible states to show promotions for ApprovalPM report */

Promotion.REPORTS_APPROVAL_PM_STATES = immutable_1.List.of(PromotionStateEnum_1.PromotionStateEnum.Concept, PromotionStateEnum_1.PromotionStateEnum.Open, PromotionStateEnum_1.PromotionStateEnum.Closed);
Promotion.REPORTS_REPLE_PROMO_MANAGEMENT_STATES = immutable_1.List.of(PromotionStateEnum_1.PromotionStateEnum.Active, PromotionStateEnum_1.PromotionStateEnum.Finalized, PromotionStateEnum_1.PromotionStateEnum.Closed, PromotionStateEnum_1.PromotionStateEnum.Finished, PromotionStateEnum_1.PromotionStateEnum.Evaluated);
/** States in which is possible to create the Forecast simulation */

Promotion.FORECAST_SIMULATION_STATES = immutable_1.List.of(PromotionStateEnum_1.PromotionStateEnum.Open, PromotionStateEnum_1.PromotionStateEnum.Approved, PromotionStateEnum_1.PromotionStateEnum.Closed);
Promotion.FORECAST_CHANGE_STATES = immutable_1.List.of(PromotionStateEnum_1.PromotionStateEnum.Open, PromotionStateEnum_1.PromotionStateEnum.Approved, PromotionStateEnum_1.PromotionStateEnum.Closed);
/** States used to find historical window items */

Promotion.HISTORICAL_PRODUCTS_STATES = immutable_1.List.of(PromotionStateEnum_1.PromotionStateEnum.Finished, PromotionStateEnum_1.PromotionStateEnum.Evaluated);
/** States in witch promo can be approved */

Promotion.APPROVABLE_STATES = immutable_1.List.of(PromotionStateEnum_1.PromotionStateEnum.Concept, PromotionStateEnum_1.PromotionStateEnum.Open, PromotionStateEnum_1.PromotionStateEnum.Closed);
/** States after the Closed state (inclusive). Such a promotions are reported in Shelfplanning report (LOG-7501). */

Promotion.CLOSED_AND_AFTER_STATES = immutable_1.List.of(PromotionStateEnum_1.PromotionStateEnum.Closed, PromotionStateEnum_1.PromotionStateEnum.Finalized, PromotionStateEnum_1.PromotionStateEnum.Active, PromotionStateEnum_1.PromotionStateEnum.Finished, PromotionStateEnum_1.PromotionStateEnum.Evaluated, PromotionStateEnum_1.PromotionStateEnum.Canceled);

Promotion.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(Promotion.name);
  return {
    id: builder.id('id'),
    externalId: builder.str('externalId'),
    workflowCaseId: builder.opt(builder.str('workflowCaseId')),
    workflowState: builder.opt(builder.senum('workflowState', PromotionStateEnum_1.PromotionStateEnum, CodebookLookupSequence_1.CodebookLookupSequence.PromotionWorkflowState)),
    workflowModified: builder.opt(builder.date('workflowModified', DateParser_1.DateParser.ISO_PATTERN)),
    name: builder.trimStr('name'),
    promotionTypeId: builder.lookup('promotionTypeId', CodebookLookupSequence_1.CodebookLookupSequence.PromotionTypes),
    description: builder.opt(builder.trimStr('description', new StringLengthValidator_1.StringLengthValidator(1, 255)).withDescription({
      multiline: true
    })),
    dateFrom: builder.date('dateFrom', DateParser_1.DateParser.ISO_PATTERN),
    dateTo: builder.date('dateTo', DateParser_1.DateParser.ISO_PATTERN),
    groupOfSitesId: builder.lookup('groupOfSitesId', CodebookLookupSequence_1.CodebookLookupSequence.GroupOfSites),
    ecommerce: builder.bool('ecommerce'),
    opening: builder.bool('opening'),
    storeSpecification: builder.senum('storeSpecification', StoreSpecificationEnum_1.StoreSpecificationEnum, CodebookLookupSequence_1.CodebookLookupSequence.StoreSpecification),
    themeIds: builder.opt(builder.listOf(builder.lookup('themeIds', CodebookLookupSequence_1.CodebookLookupSequence.Theme))),
    created: builder.date('created', DateParser_1.DateParser.ISO_PATTERN),
    createdBy: builder.obj('createdBy', UserInfo_1.UserInfo.schema, function (mat) {
      return new UserInfo_1.UserInfo(mat.id, mat.name);
    }),
    modified: builder.date('modified', DateParser_1.DateParser.ISO_PATTERN),
    modifiedBy: builder.obj('modifiedBy', UserInfo_1.UserInfo.schema, function (mat) {
      return new UserInfo_1.UserInfo(mat.id, mat.name);
    }),
    stateFlags: builder.flags('stateFlags', EntityStateFlag_1.EntityStateFlag),
    assignedMasterArea: builder.bool('assignedMasterArea'),
    lastEffect: builder.date('lastEffect', DateParser_1.DateParser.ISO_PATTERN),
    promoSplitOption: builder.senum('promoSplitOption', PromotionSplitOptionEnum_1.PromotionSplitOptionsEnum, CodebookLookupSequence_1.CodebookLookupSequence.PromotionSplitOptions),
    manualSplits: builder.listOf(builder.obj('manualSplits', ManualPromoWeekSplit_1.ManualPromoWeekSplit.schema, function (mat) {
      return ManualPromoWeekSplit_1.ManualPromoWeekSplit.fromDataDict(mat);
    })),
    warningFlags: builder.flags('warningFlags', PromotionWarningFlag_1.PromotionWarningFlag),
    processed: builder.bool('processed'),
    snapshotOriginId: builder.opt(builder.id('snapshotOriginId'))
  };
}();